import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Log Firebase configuration (with API key partially masked for security)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Log sanitized config for debugging (hide sensitive parts of API key)
const sanitizedConfig = {
  ...firebaseConfig,
  apiKey: firebaseConfig.apiKey ? `${firebaseConfig.apiKey.substring(0, 5)}...${firebaseConfig.apiKey.substring(firebaseConfig.apiKey.length - 5)}` : 'MISSING',
  appId: firebaseConfig.appId ? '**********' : 'MISSING'
};

console.log('[Firebase] Initializing with config:', sanitizedConfig);

// Check if required Firebase config values are present
const missingConfigValues = Object.entries(firebaseConfig)
  .filter(([key, value]) => !value)
  .map(([key]) => key);

if (missingConfigValues.length > 0) {
  console.error('[Firebase] Missing required config values:', missingConfigValues);
  console.warn('[Firebase] Check that your environment variables are properly set up');
}

// Initialize Firebase and define exports
let app;
let auth;
let db;

try {
  console.log('[Firebase] Attempting to initialize Firebase app');
  app = initializeApp(firebaseConfig);
  console.log('[Firebase] Firebase app initialized successfully');
  
  console.log('[Firebase] Initializing authentication service');
  auth = getAuth(app);
  console.log('[Firebase] Auth service initialized with config:', {
    currentUser: auth.currentUser ? 'User present' : 'No user logged in',
    authDomain: auth.config.authDomain
  });
  
  console.log('[Firebase] Initializing Firestore database');
  db = getFirestore(app);
  console.log('[Firebase] Firestore initialized successfully');
} catch (error) {
  console.error('[Firebase] Error initializing Firebase:', error);
  
  // Create fallback objects to prevent application from crashing
  console.warn('[Firebase] Using fallback empty Firebase objects to prevent app crashes');
  app = {};
  auth = {};
  db = {};
}

// Export the Firebase services
export { auth, db };
export default app; 